import { render, staticRenderFns } from "./revenueForProprietor.vue?vue&type=template&id=1e06f7c3&scoped=true"
import script from "./revenueForProprietor.vue?vue&type=script&lang=js"
export * from "./revenueForProprietor.vue?vue&type=script&lang=js"
import style0 from "./revenueForProprietor.vue?vue&type=style&index=0&id=1e06f7c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06f7c3",
  null
  
)

export default component.exports